export default function getViewStoreName(name) {
	return name.charAt(0).toLowerCase() + name.slice(1);
}



// WEBPACK FOOTER //
// ./src/core/utils/getViewStoreName.js